const permissions = [
  {
    value: "all",
    label: "All",
    children: [
      {
        value: "dashboard-list",
        label: "Dashboard",
      },
      {
        value: "setting-edit",
        label: "Setting",
      },

      {
        value: "training",
        label: "Training",
        children: [
          {
            value: "training-list",
            label: "List",
          },
          {
            value: "training-add",
            label: "Add",
          },
          {
            value: "training-edit",
            label: "Edit",
          },
          {
            value: "training-delete",
            label: "Delete",
          },
          {
            value: "training-print-certificate",
            label: "Print Certificate",
          },
          {
            value: "training-email-log",
            label: "Training view email log",
          },
          {
            value: "training-send-mail",
            label: "Send Mail to all trainee in training",
          },
          {
            value: "training-view-mail-log",
            label: "View Mail Log",
          },
          {
            value: "trainee-view",
            label: "Trainees",
            children: [
              {
                value: "training-view-trainee",
                label: "Trainees View",
              },
              {
                value: "training-trainee-add",
                label: "Add Trainees",
              },
              {
                value: "training-trainee-edit",
                label: "Edit Trainees",
              },
              {
                value: "training-trainee-delete",
                label: "Delete Trainees",
              },
              {
                value: "training-trainee-send-mail",
                label: "Send Mail to particular trainee",
              },
            ],
          },
          {
            value: "session-view",
            label: "Session View",
            children: [
              {
                value: "training-view-session",
                label: "View Session",
              },
              {
                value: "training-session-add",
                label: "Add Session",
              },
              {
                value: "training-session-edit",
                label: "Edit Session",
              },
              {
                value: "training-session-delete",
                label: "Delete Session",
              },
              {
                value: "training-session-view-attendance",
                label: "View Attendance",
              },
              {
                value: "training-session-update-attendance",
                label: "Update Attendance",
              },
            ],
          },
        ],
      },
      {
        value: "training-type",
        label: "Training Type",
        children: [
          {
            value: "training-type-list",
            label: "List",
          },
          {
            value: "training-type-add",
            label: "Add",
          },
          {
            value: "training-type-edit",
            label: "Edit",
          },
          {
            value: "training-type-delete",
            label: "Delete",
          },
        ],
      },
      {
        value: "trainee-approval",
        label: "Trainee Approval",
      },
      {
        value: "trainer",
        label: "Trainer",
        children: [
          {
            value: "trainer-list",
            label: "List",
          },
          {
            value: "trainer-add",
            label: "Add",
          },
          {
            value: "trainer-edit",
            label: "Edit",
          },
          {
            value: "trainer-delete",
            label: "Delete",
          },
        ],
      },
      {
        value: "cost-management",
        label: "Cost Management",
        children: [
          {
            value: "cost-management-list",
            label: "Show",
          },
          {
            value: "cost-management-edit",
            label: "Update",
          },
        ],
      },
      {
        value: "user",
        label: "User",
        children: [
          {
            value: "user-list",
            label: "List",
          },
          {
            value: "user-add",
            label: "Add",
          },
          {
            value: "user-edit",
            label: "Edit",
          },
          {
            value: "user-delete",
            label: "Delete",
          },
        ],
      },
      {
        value: "role",
        label: "Role",
        children: [
          {
            value: "role-list",
            label: "List",
          },
          {
            value: "role-add",
            label: "Add",
          },
          {
            value: "role-edit",
            label: "Edit",
          },
          {
            value: "role-delete",
            label: "Delete",
          },
        ],
      },
      {
        value: "email-template",
        label: "Email Template",
        children: [
          {
            value: "email-template-list",
            label: "Show",
          },
          {
            value: "email-template-edit",
            label: "Update",
          },
        ],
      },
      {
        value: "setting",
        label: "Setting Management",
        children: [
          {
            value: "setting-list",
            label: "Show",
          },
          {
            value: "setting-edit",
            label: "Update",
          },
        ],
      },
    ],
  },
];

// [
//     {
//         title: 'Dashboard',
//     },
//     {
//         title: "Book_Entry",
//     },
//     {
//         title: "Book_Entry_Edit",
//     },
//     {
//         title: "Book_Edit",
//     },
//     {
//         title: "Book_Add",
//     },
//     {
//         title: "Book_Detail",
//     },
//     {
//         title: "Book_List",
//     },
//     {
//         title: "Book_Delete",
//     },
//     {
//         title: "Book_Type_Add",
//     },
//     {
//         title: "Book_Type_Edit",
//     },
//     {
//         title: "Book_Type_List",
//     },
//     {
//         title: "Book_Type_Delete",
//     },
//     {
//         title: "Member_Add",
//     },
//     {
//         title: "Member_Edit",
//     },
//     {
//         title: "Member_List",
//     },
//     {
//         title: "Member_Delete",
//     },
//     {
//         title: "Member_Type_Add",
//     },
//     {
//         title: "Member_Type_Edit",
//     },
//     {
//         title: "Member_Type_List",
//     },
//     {
//         title: "Member_Type_Delete",
//     },
//     {
//         title: "Category_Add",
//     },
//     {
//         title: "Category_Edit",
//     },
//     {
//         title: "Category_List",
//     },
//     {
//         title: "Category_Delete",
//     },
//     {
//         title: "Sub_Category_Add",
//     },
//     {
//         title: "Sub_Category_Edit",
//     },
//     {
//         title: "Sub_Category_List",
//     },
//     {
//         title: "Sub_Category_Delete",
//     },
//     {
//         title: "Edition_Add",
//     },
//     {
//         title: "Edition_Edit",
//     },
//     {
//         title: "Edition_List",
//     },
//     {
//         title: "Edition_Delete",
//     },
//     {
//         title: "Rack_Add",
//     },
//     {
//         title: "Rack_Edit",
//     },
//     {
//         title: "Rack_List",
//     },
//     {
//         title: "Rack_Delete",
//     },
//     {
//         title: "Room_Add",
//     },
//     {
//         title: "Room_Edit",
//     },
//     {
//         title: "Room_List",
//     },
//     {
//         title: "Room_Delete",
//     }
//     ,
//     {
//         title: "Settings_Edit",
//     }

// ];

export default permissions;
